import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';

type Props = {
  onClose: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
};

export default function ContactConfirmModal({ onClose, onSubmit, isSubmitting = false }: Props) {
  return (
    <Modal width='clamp(320px, 90vw, 560px)'>
      <div className='relative flex flex-col gap-6 p-8'>
        <button
          type='button'
          onClick={onClose}
          aria-label='閉じる'
          data-testid='contact-confirm-modal-close'
          disabled={isSubmitting}
          className='absolute right-4 top-4 flex size-8 items-center justify-center rounded-full text-black transition-colors hover:bg-gray-100 hover:text-gray-600 disabled:cursor-not-allowed disabled:opacity-40'
        >
          <svg
            className='size-5'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M6 18L18 6M6 6l12 12'
            />
          </svg>
        </button>

        <div className='flex flex-col gap-4 border-b border-solid border-gray-200 pb-4'>
          <h2 className='text-lg font-semibold'>送信の確認</h2>
        </div>

        <p className='text-sm'>「送信」を押すと入力内容が送信されます。</p>

        <div className='flex justify-center gap-4'>
          <div className='w-[200px]'>
            <Button
              outline
              fullRounded
              fullWidth
              variant='secondary'
              onClick={onClose}
              disabled={isSubmitting}
              data-testid='contact-confirm-modal-cancel'
            >
              キャンセル
            </Button>
          </div>
          <div className='w-[200px]'>
            <Button
              outline
              fullRounded
              fullWidth
              onClick={onSubmit}
              disabled={isSubmitting}
              data-testid='contact-confirm-modal-submit'
            >
              送信
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
